import React from 'react';
import { Document, Page, Text, StyleSheet,Font , Image } from '@react-pdf/renderer';

// Create styles
Font.register({
  family: 'Oswald',
  src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Oswald'
  },
  text: {
    margin: 12,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Times-Roman'
  },
  textSignature: {
    margin: 1,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Oswald'
  },
  image: {
    textAlign: 'left',
    width: '141px',
    height: '20,5px'
  },
  imageSignature: {
    marginVertical: 3,
    marginHorizontal: 170,
    textAlign: 'center !important',
    justifyContent: 'center',
    width: '182px',
    height: '41px'
  },
});

const CertificateSeniorityPDF = ({logoImg, signatureImg, title, firstText, secondText, representative, workPosition, business, date}) => {
    return ( 
        <>
          <Document>
            <Page style={styles.body}>
              <Image
                style={styles.image}               
                src={logoImg}
              />
              <Text style={styles.title}>{title}</Text>
              <Text style={styles.text}/>
              <Text style={styles.text}>
                {firstText}
              </Text>
              <Text style={styles.text}>
                {secondText}
              </Text>
              <Text style={styles.text}/>
              
              <Image
                style={styles.imageSignature}               
                src={signatureImg}
              />
              <Text style={styles.textSignature}>
                {representative}
              </Text>
              <Text style={styles.textSignature}>
                {workPosition}
              </Text>
              <Text style={styles.textSignature}>
                {business}
              </Text>    
              <Text style={styles.text}>
                {date}
              </Text>         
            </Page>
          </Document>
        </>    
     );
}
 
export default CertificateSeniorityPDF;